(function () {
  function initFeaturedCollectionMobile(container) {
    if (!container || !window.FoxTheme || !window.FoxTheme.Carousel) return;

    const panels = container.querySelectorAll('.featured-collection-mobile__panel');
    const tabBtns = container.querySelectorAll('[data-mobile-tab]');
    const swiperInstances = [];

    panels.forEach((panel) => {
      const swiperEl = panel.querySelector('.featured-collection-mobile__swiper');
      const wrapper = panel.querySelector('.featured-collection-mobile__wrapper');
      if (!swiperEl || !wrapper || wrapper.querySelectorAll('.swiper-slide').length === 0) return;

      const prevEl = panel.querySelector('.swiper-button-prev');
      const nextEl = panel.querySelector('.swiper-button-next');

      const options = {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: false,
        autoHeight: true,
        navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,
      };

      const carousel = new window.FoxTheme.Carousel(swiperEl, options);
      carousel.init();
      swiperInstances.push({ panel, carousel });
    });

    tabBtns.forEach((btn) => {
      btn.addEventListener('click', function () {
        const index = parseInt(this.getAttribute('data-index'), 10);
        if (isNaN(index)) return;

        tabBtns.forEach((b) => b.classList.remove('active'));
        this.classList.add('active');

        panels.forEach((panel) => {
          const panelIndex = parseInt(panel.getAttribute('data-index'), 10);
          panel.hidden = panelIndex !== index;
          if (panelIndex === index && panel.hidden === false) {
            const found = swiperInstances.find((s) => s.panel === panel);
            if (found && found.carousel.slider) {
              found.carousel.slider.updateSize();
              found.carousel.slider.updateSlides();
              if (found.carousel.slider.updateAutoHeight) {
                found.carousel.slider.updateAutoHeight();
              }
            }
          }
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.featured-collection-mobile').forEach(initFeaturedCollectionMobile);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target;
    const mobile = section.querySelector('.featured-collection-mobile');
    if (mobile) initFeaturedCollectionMobile(mobile);
  });
})();
